import EmployedPrimary from './EmployedPrimary';
import EmployedSecondary from './EmployedSecondary';

import { EmploymentClassType } from '../../PrimaryEmployment/types';

export interface PrimaryEmployedProps {
  type: Extract<EmploymentClassType, 'primary'>;
}

export interface SecondaryEmployedProps {
  type: Extract<EmploymentClassType, 'secondary'>;
  index: number;
  arrayName: string;
}

export type EmployedProps = PrimaryEmployedProps | SecondaryEmployedProps;

const Employed: React.FunctionComponent<EmployedProps> = function (props) {
  const { type } = props;
  if (type === 'secondary') {
    const { index, arrayName } = props;
    return <EmployedSecondary index={index} arrayName={arrayName} />;
  }
  return <EmployedPrimary />;
};

export default Employed;
